module.exports = __webpack_public_path__ + "static/contact-background-c2b23bbe4aa119e4188d2530fd64c14b.jpg";